import React from "react";

function PoliticaPrivacidad() {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f5f6f8",
        padding: "40px 20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "850px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          color: "#333",
          lineHeight: "1.6",
        }}
      >
        {/* Título */}
        <h1
          style={{
            marginTop: 0,
            marginBottom: "10px",
            color: "#222",
          }}
        >
          Política de Privacidad
        </h1>

        <p
          style={{
            color: "#777",
            fontSize: "14px",
            marginBottom: "30px",
          }}
        >
          Última actualización: septiembre de 2026
          <br />
          Versión 1.0
        </p>

        <hr />

        {/* 1 */}
        <h2>1. ¿Qué información consulta Inlazuai?</h2>

        <p>
          Cuando conectas tu cuenta de Odoo, Inlazuai accede{" "}
          <strong>únicamente en modo de lectura</strong> a la información
          necesaria para generar los Insights contratados.
        </p>

        <p>
          La integración puede consultar los siguientes modelos de Odoo:
        </p>

        <ul>
          <li>
            <strong>product.product</strong> — Variantes de producto
          </li>
          <li>
            <strong>product.template</strong> — Productos
          </li>
          <li>
            <strong>stock.quant</strong> — Cantidades de inventario
          </li>
          <li>
            <strong>uom.uom</strong> — Unidades de medida
          </li>
          <li>
            <strong>sale.order</strong> — Pedidos de venta
          </li>
          <li>
            <strong>sale.order.line</strong> — Líneas de pedidos
          </li>
          <li>
            <strong>pos.order</strong> — Pedidos del punto de venta
          </li>
          <li>
            <strong>pos.order.line</strong> — Líneas del punto de venta
          </li>
          <li>
            <strong>stock.move</strong> — Movimientos de inventario
          </li>
          <li>
            <strong>mrp.bom</strong> — Listas de materiales
          </li>
          <li>
            <strong>mrp.bom.line</strong> — Líneas de listas de materiales
          </li>
        </ul>

        {/* 2 */}
        <h2>2. ¿Para qué utilizamos esta información?</h2>

        <p>
          La información se utiliza exclusivamente para proporcionar las
          funcionalidades de Inlazuai, incluyendo:
        </p>

        <ul>
          <li>Análisis de inventario.</li>
          <li>Análisis de ventas.</li>
          <li>Identificación de productos sin rotación.</li>
          <li>
            Identificación de riesgos de agotamiento o exceso de inventario.
          </li>
          <li>Análisis de productos y listas de materiales.</li>
          <li>Generación de indicadores, Insights y recomendaciones.</li>
        </ul>

        {/* 3 */}
        <h2>3. ¿Inlazuai puede modificar mi Odoo?</h2>

        <p>
          <strong>No.</strong>
        </p>

        <p>
          La integración está diseñada para utilizar permisos de{" "}
          <strong>solo lectura</strong>. Inlazuai no crea, modifica ni elimina
          productos, pedidos, movimientos de inventario, listas de materiales
          ni otros registros de los modelos utilizados para los Insights.
        </p>

        {/* 4 */}
        <h2>4. ¿Cómo protegemos la información?</h2>

        <p>
          Inlazuai aplica medidas técnicas y de seguridad razonables para
          proteger la información utilizada por la plataforma y limitar el
          acceso únicamente a los servicios que necesitan procesarla.
        </p>

        {/* 5 */}
        <h2>5. ¿Compartimos la información?</h2>

        <p>
          Inlazuai <strong>no vende la información obtenida de Odoo</strong>.
        </p>

        <p>
          La información podrá ser procesada por proveedores tecnológicos
          necesarios para operar la plataforma, como servicios de
          infraestructura, almacenamiento o bases de datos.
        </p>

        {/* 6 */}
        <h2>6. Autorización</h2>

        <p>
          Antes de conectar Odoo, el usuario debe autorizar a Inlazuai a
          consultar y procesar la información necesaria para proporcionar los
          Insights.
        </p>

        <p>
          Inlazuai podrá conservar un registro de esta autorización, incluyendo
          la fecha y la versión de la política aceptada.
        </p>

        {/* 7 */}
             <hr />

        <p
          style={{
            fontSize: "13px",
            color: "#888",
            marginBottom: 0,
          }}
        >
          Inlazuai — Política de Privacidad v1.0
        </p>
      </div>
    </div>
  );
}

export default PoliticaPrivacidad;